var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgLogoHelixNew = function SvgLogoHelixNew(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    viewBox: "0 0 82.13 41.47",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3,32.55C-3.97,23.05-.7,5.74,12.16,1.36,16.09.07,20.27-.3,24.34.24c0,0,0,.11,0,.11-4.02-.14-8.1.4-11.87,1.81C0,7.1-2.3,22.57,5.3,32.55h0Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2,9.51c.1-1.51-2.03-1.67-2.17-.22-.2,1.46,2.03,1.75,2.17.22h0ZM16.28,9.52c-.17,2.05-3.28,1.71-3.11-.31.27-2.06,3.28-1.75,3.11.31h0Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46,9.18c1.95,2.26,3.91,4.36,5.39,7,.5,1,.65,2.35.23,3.43-.29.61-.59,1.23-.91,1.83-1.58,2.81-3.33,5.03-1.29,8.14.59,1.11,1.32,2.17,1.98,3.28l-.08.06c-2.87-3.44-5.13-5.84-2.39-10.26,0,0,1.8-3.39,1.8-3.39.34-.83.25-1.89-.15-2.74-.82-1.77-3.61-5.59-4.68-7.3,0,0,.08-.06.08-.06h0Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.58,6.89c-4.15,2.67-8.06,7.08-7.46,12.29.32,2.42,2.16,4.8,2.59,7.4.72,4.85-3.09,8.87-6.53,11.67,0,0-4.22,3.21-4.22,3.21l-.07-.07c4.65-4.33,12.63-9.88,9.05-17.11-1.62-3.12-2.56-6.88-.85-10.19,1.46-3.11,4.46-6,7.49-7.2h0Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.88,21.65v-12.6s1.23,0,1.23,0v5.83s7.56,0,7.56,0v-5.83s1.23,0,1.23,0v12.6s-1.23,0-1.23,0v-6.34s-7.56,0-7.56,0v6.34s-1.23,0-1.23,0Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.57,21.66v-12.6s5.49,0,5.49,0v.88l-3.15-.42c-.55-.07-.92-.11-1.12-.11v5.49c.15,0,.53-.02,1.11-.05l2.95-.18v.83l-2.95-.18c-.59-.04-.96-.05-1.12-.05v6.03c.21,0,.59-.04,1.13-.11l3.19-.41v.88s-5.54,0-5.54,0Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.89,9.06h1.22s0,12.24,0,12.24c.23,0,.59-.04,1.08-.11l2.99-.45v.92s-5.29,0-5.29,0v-12.6Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.19,21.66v-12.6h1.23v12.6h-1.23Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.33,21.66l4.65-6.28-4.28-6.32h1.44s3.54,5.24,3.54,5.24h.11l3.08-5.24h1.44s-4.32,5.71-4.32,5.71l4.68,6.9h-1.44s-3.94-5.82-3.94-5.82h-.11l-3.4,5.81h-1.44Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1,30.34v-1.21h.12v1.21h-.12ZM34.85,30.34l-.57-.62.52-.59h.15l-.57.54.62.67h-.16Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.26,30.34v-1.21h.12v1.21h-.12Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8,30.34l.04-1.23h.02l.87,1.05h.01l-.04-1.02h.12l-.04,1.23h-.02l-.87-1.05h-.01l.04,1.02h-.12Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.24,30.34v-1.21h.53v.08l-.3-.04c-.05,0-.09,0-.11,0v.53s.05,0,.11,0l.28-.02v.08l-.28-.02c-.06,0-.09,0-.11,0v.58s.06,0,.11-.01l.31-.04v.08h-.53Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.03,30.3v-.1h.02s.1.07.15.09c.06.02.11.03.17.03.08,0,.14-.02.19-.06.05-.04.07-.1.07-.17,0-.04,0-.08-.03-.11-.02-.04-.05-.07-.09-.11-.04-.04-.1-.07-.17-.12-.05-.03-.1-.06-.14-.09s-.08-.07-.11-.11c-.03-.04-.04-.09-.04-.15,0-.09.03-.16.09-.21s.15-.08.25-.08c.05,0,.1,0,.15.01s.09.02.12.04v.1h-.02c-.07-.07-.15-.11-.25-.11-.07,0-.13.02-.18.06-.04.04-.07.09-.07.15,0,.05.01.09.04.12.02.03.06.06.1.09.04.03.08.05.13.08.05.03.1.06.15.09s.09.07.12.12c.03.05.05.1.05.17,0,.06-.02.12-.04.17-.03.05-.07.09-.13.11-.05.03-.12.04-.19.04-.05,0-.1,0-.16-.02-.06-.01-.12-.03-.18-.04Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.07,30.34v-1.21h.12v1.21h-.12Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.92,30.34v-1.17s-.05,0-.11,0l-.34.04v-.09h1.01v.09l-.34-.04c-.05,0-.09,0-.11,0v1.17h-.12Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.76,30.34v-1.21h.12v.56h.72v-.56h.12v1.21h-.12v-.61h-.72v.61h-.12Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.17,30.34v-1.21h.53v.08l-.3-.04c-.05,0-.09,0-.11,0v.53s.05,0,.11,0l.28-.02v.08l-.28-.02c-.06,0-.09,0-.11,0v.58s.06,0,.11-.01l.31-.04v.08h-.53Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.06,29.14h.23c.12,0,.22.03.28.08.07.05.1.12.1.21,0,.07-.02.13-.06.18s-.1.08-.18.09h0c.08.03.14.06.19.12.05.06.08.13.11.21.02.08.04.13.07.18.02.04.04.07.07.09.03.02.06.03.09.04h0s-.07.01-.07.01c-.05,0-.09,0-.12-.03-.03-.02-.06-.05-.08-.09-.02-.04-.04-.1-.07-.18-.03-.12-.08-.2-.13-.25-.05-.05-.12-.07-.2-.07h-.01v-.03h.01c.18,0,.28-.08.28-.25s-.09-.25-.26-.25h-.11v1.17h-.12v-1.21Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.04,30.34l.46-1.21h.11l.46,1.21h-.13l-.21-.57h-.39l-.18.57h-.13ZM44.51,29.23l-.16.51h.36l-.19-.51h-.01Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.35,30.34v-1.21h.21c.14,0,.25.03.33.09.08.06.12.14.12.25s-.04.19-.12.25c-.08.06-.19.09-.33.09h-.1v.54h-.12ZM45.57,29.18h-.1v.59h.1c.21,0,.32-.1.32-.29s-.11-.29-.32-.29Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.34,30.34v-1.21h.12v1.21h-.12Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9,30.35v-1.21h.53v.08l-.3-.04c-.05,0-.09,0-.11,0v.53s.05,0,.11,0l.28-.02v.08l-.28-.02c-.06,0-.09,0-.11,0v.58s.06,0,.11-.01l.31-.04v.08h-.53Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7,30.27s0-.05.03-.06.04-.03.07-.03c.03,0,.06.01.07.04s.03.06.03.1c0,.06-.01.11-.04.16s-.07.09-.12.12l-.02-.03c.08-.06.12-.14.13-.25-.01.02-.03.03-.06.03-.02,0-.04,0-.06-.02-.01-.02-.02-.04-.02-.06Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.48,30.35h-.92v-.03l.77-1.14s-.06,0-.13,0l-.6.04v-.08h.86v.03l-.77,1.14s.06,0,.13,0l.65-.05v.09Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.68,29.74c0-.09.02-.17.05-.25.03-.08.08-.14.13-.2.06-.06.12-.1.2-.13.08-.03.16-.05.25-.05s.17.02.25.05c.08.03.14.08.2.13.06.06.1.12.13.2.03.08.05.16.05.25s-.02.17-.05.25c-.03.08-.08.14-.13.2-.06.06-.12.1-.2.13-.08.03-.16.05-.25.05s-.17-.02-.25-.05c-.08-.03-.14-.08-.2-.13s-.1-.12-.13-.2c-.03-.08-.05-.16-.05-.25ZM49.81,29.74c0,.12.02.22.06.31.04.09.1.16.17.21.07.05.16.07.26.07s.19-.02.26-.07.13-.12.17-.21c.04-.09.06-.19.06-.31s-.02-.22-.06-.31c-.04-.09-.1-.16-.17-.21-.08-.05-.16-.07-.26-.07s-.19.02-.26.07-.13.12-.17.2c-.04.09-.06.19-.06.31Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3,29.14h.23c.12,0,.22.03.28.08.07.05.1.12.1.21,0,.07-.02.13-.06.18s-.1.08-.18.09h0c.08.03.14.06.19.12.05.06.08.13.11.21.02.08.04.13.07.18.02.04.04.07.07.09.03.02.06.03.09.04h0s-.07.01-.07.01c-.05,0-.09,0-.12-.03-.03-.02-.06-.05-.08-.09-.02-.04-.04-.1-.07-.18-.03-.12-.08-.2-.13-.25-.05-.05-.12-.07-.2-.07h-.01v-.03h.01c.18,0,.28-.08.28-.25s-.09-.25-.26-.25h-.11v1.17h-.12v-1.21Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.97,29.77v-.04h.44v.47c-.05.05-.12.09-.19.12-.08.03-.16.04-.26.04s-.19-.02-.27-.05c-.08-.03-.15-.08-.21-.13-.06-.06-.11-.12-.14-.2-.03-.08-.05-.16-.05-.25s.02-.17.05-.25c.03-.08.08-.14.14-.2.06-.06.13-.1.21-.13.08-.03.17-.05.27-.05.04,0,.09,0,.14,0s.1.01.14.02.08.02.11.04v.1h-.02s-.1-.07-.17-.09-.13-.03-.21-.03c-.11,0-.2.02-.28.07-.08.05-.15.12-.19.21-.04.09-.07.19-.07.31s.02.22.07.31c.05.09.11.16.19.21.08.05.18.07.28.07.07,0,.13,0,.19-.03s.11-.04.15-.08v-.45h-.32Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.94,29.14v1.21h-.12v-1.11h-.01l-.42.8h-.05l-.47-.71h-.01l.04,1.01h-.12l.04-1.23h.04l.54.81h.01l.41-.78h.12Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.21,30.35l.46-1.21h.11l.46,1.21h-.13l-.21-.57h-.39l-.18.57h-.13ZM55.68,29.23l-.16.51h.36l-.19-.51h-.01Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.42,30.31v-.1h.02s.1.07.15.09c.06.02.11.03.17.03.08,0,.14-.02.19-.06.05-.04.07-.1.07-.17,0-.04,0-.08-.03-.11-.02-.04-.05-.07-.09-.11-.04-.04-.1-.07-.17-.12-.05-.03-.1-.06-.14-.09s-.08-.07-.11-.11c-.03-.04-.04-.09-.04-.15,0-.09.03-.16.09-.21s.15-.08.25-.08c.05,0,.1,0,.15.02.05,0,.09.02.12.04v.1h-.02c-.07-.07-.15-.11-.25-.11-.07,0-.13.02-.18.06-.04.04-.07.09-.07.15,0,.05.01.09.04.12.02.03.06.06.1.09.04.03.08.05.13.08.05.03.1.06.15.1.05.03.09.07.12.12.03.05.05.1.05.17,0,.06-.02.12-.04.17-.03.05-.07.09-.13.11s-.12.04-.19.04c-.05,0-.1,0-.16-.02-.06-.01-.12-.03-.18-.04Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.35,30.31v-.1h.02s.1.07.15.09c.06.02.11.03.17.03.08,0,.14-.02.19-.06.05-.04.07-.1.07-.17,0-.04,0-.08-.03-.11-.02-.04-.05-.07-.09-.11-.04-.04-.1-.07-.17-.12-.05-.03-.1-.06-.14-.09s-.08-.07-.11-.11c-.03-.04-.04-.09-.04-.15,0-.09.03-.16.09-.21s.15-.08.25-.08c.05,0,.1,0,.15.01s.09.02.12.04v.1h-.02c-.07-.07-.15-.11-.25-.11-.07,0-.13.02-.18.06-.04.04-.07.09-.07.15,0,.05.01.09.04.12.02.03.06.06.1.09.04.03.08.05.13.08.05.03.1.06.15.09s.09.07.12.12c.03.05.05.1.05.17,0,.06-.02.12-.04.17-.03.05-.07.09-.13.11-.05.03-.12.04-.19.04-.05,0-.1,0-.16-.02-.06-.01-.12-.03-.18-.04Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.22,30.35l.46-1.21h.11l.46,1.21h-.13l-.21-.57h-.39l-.18.57h-.13ZM58.69,29.23l-.16.51h.36l-.19-.51h-.01Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.12,29.78v-.04h.44v.47c-.05.05-.12.09-.19.12-.08.03-.16.04-.26.04s-.19-.02-.27-.05c-.08-.03-.15-.08-.21-.13-.06-.06-.11-.12-.14-.2-.03-.08-.05-.16-.05-.25s.02-.17.05-.25c.03-.08.08-.14.14-.2.06-.06.13-.1.21-.13.08-.03.17-.05.27-.05.04,0,.09,0,.14,0s.1.01.14.02c.04.01.08.02.11.04v.1h-.02s-.1-.07-.17-.09-.13-.03-.21-.03c-.11,0-.2.02-.28.07-.08.05-.15.12-.19.21-.04.09-.07.19-.07.31s.02.22.07.31c.05.09.11.16.19.21.08.05.18.07.28.07.07,0,.13,0,.19-.03s.11-.04.15-.08v-.45h-.32Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.95,30.35v-1.21h.53v.08l-.3-.04c-.05,0-.09,0-.11,0v.53s.05,0,.11,0l.28-.02v.08l-.28-.02c-.06,0-.09,0-.11,0v.58s.06,0,.11-.01l.31-.04v.08h-.53Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.09,30.35l-.16-.18c-.05.07-.1.12-.15.15-.05.03-.12.05-.19.05s-.14-.01-.2-.04c-.06-.03-.1-.06-.13-.11-.03-.05-.05-.11-.05-.17,0-.08.02-.15.07-.21s.12-.11.21-.15v-.02c-.07-.06-.1-.11-.13-.16-.02-.05-.03-.09-.03-.14,0-.08.02-.14.07-.19.05-.05.11-.07.2-.07s.14.02.19.06.07.1.07.17c0,.06-.02.12-.06.18-.04.06-.1.1-.17.14l.34.37.12-.32h.12l-.21.35.26.28h-.15ZM62.32,30.04c0,.09.03.16.08.21.05.05.12.08.2.08.12,0,.21-.06.3-.19l-.39-.42c-.13.07-.19.17-.19.32ZM62.55,29.6l.05.05c.1-.07.15-.16.15-.28,0-.07-.01-.12-.04-.15-.03-.04-.06-.05-.11-.05s-.09.02-.12.05c-.03.04-.05.08-.05.14,0,.04,0,.08.03.12.02.04.05.08.09.13Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.81,29.14h.13s.47,1.07.47,1.07h.01l.39-1.07h.13l-.55,1.23h-.04l-.55-1.23Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.11,29.75c0-.09.02-.17.05-.25.03-.08.08-.14.13-.2.06-.06.12-.1.2-.13.08-.03.16-.05.25-.05s.17.02.25.05c.08.03.14.08.2.13.06.06.1.12.13.2.03.08.05.16.05.25s-.02.17-.05.25c-.03.08-.08.14-.13.2-.06.06-.12.1-.2.13-.08.03-.16.05-.25.05s-.17-.02-.25-.05c-.08-.03-.14-.08-.2-.13s-.1-.12-.13-.2c-.03-.08-.05-.16-.05-.25ZM65.24,29.75c0,.12.02.22.06.31.04.09.1.16.17.21.07.05.16.07.26.07s.19-.02.26-.07.13-.12.17-.21c.04-.09.06-.19.06-.31s-.02-.22-.06-.31c-.04-.09-.1-.16-.17-.21-.08-.05-.16-.07-.26-.07s-.19.02-.26.07-.13.12-.17.21c-.04.09-.06.19-.06.31Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.73,30.35v-1.21h.53v.08l-.3-.04c-.05,0-.09,0-.11,0v.53s.05,0,.11,0l.28-.02v.08l-.28-.02c-.06,0-.09,0-.11,0v.58s.06,0,.11-.01l.31-.04v.08h-.53Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.89,30.35v-1.17s-.05,0-.11,0l-.34.04v-.09h1.01v.09l-.34-.04c-.05,0-.09,0-.11,0v1.17h-.12Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.74,29.14h.23c.12,0,.22.03.28.08.07.05.1.12.1.21,0,.07-.02.13-.06.18s-.1.08-.18.09h0c.08.03.14.06.19.12.05.06.08.13.11.21.02.08.04.13.07.18.02.04.04.07.07.09.03.02.06.03.09.04h0s-.07.01-.07.01c-.05,0-.09,0-.12-.03-.03-.02-.06-.05-.08-.09-.02-.04-.04-.1-.07-.18-.03-.12-.08-.2-.13-.25-.05-.05-.12-.07-.2-.07h-.01v-.03h.01c.18,0,.28-.08.28-.25s-.09-.25-.26-.25h-.11v1.17h-.12v-1.21Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.85,30.35v-1.21h.53v.08l-.3-.04c-.05,0-.09,0-.11,0v.53s.05,0,.11,0l.28-.02v.08l-.28-.02c-.06,0-.09,0-.11,0v.58s.06,0,.11-.01l.31-.04v.08h-.53Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.74,30.35v-1.21h.51v.08l-.29-.04c-.05,0-.09,0-.1-.01v.54s.05,0,.11,0l.26-.02v.08l-.26-.02c-.05,0-.09,0-.11,0v.6h-.12Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.58,29.15h.12v1.17s.06,0,.1-.01l.29-.04v.09h-.51v-1.21Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.38,30.35v-1.21h.53v.08l-.3-.04c-.05,0-.09,0-.11,0v.53s.05,0,.11,0l.28-.02v.08l-.28-.02c-.06,0-.09,0-.11,0v.58s.06,0,.11-.01l.31-.04v.08h-.53Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1,30.35l.44-.6-.41-.61h.14l.34.5h.01l.29-.5h.14l-.41.55.45.66h-.14l-.38-.56h0l-.33.56h-.14Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.23,29.75c0-.09.02-.17.05-.25.03-.08.08-.14.13-.2.06-.06.12-.1.2-.13.08-.03.16-.05.25-.05s.17.02.25.05c.08.03.14.08.2.13.06.06.1.12.13.2.03.08.05.16.05.25s-.02.17-.05.25c-.03.08-.08.14-.13.2-.06.06-.12.1-.2.13-.08.03-.16.05-.25.05s-.17-.02-.25-.05c-.08-.03-.14-.08-.2-.13s-.1-.12-.13-.2c-.03-.08-.05-.16-.05-.25ZM74.36,29.75c0,.12.02.22.06.31.04.09.1.16.17.21.07.05.16.07.26.07s.19-.02.26-.07.13-.12.17-.21c.04-.09.06-.19.06-.31s-.02-.22-.06-.31c-.04-.09-.1-.16-.17-.21-.08-.05-.16-.07-.26-.07s-.19.02-.26.07-.13.12-.17.21c-.04.09-.06.19-.06.31Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.85,29.15h.12v1.17s.06,0,.1-.01l.29-.04v.09h-.51v-1.21Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.51,29.75c0-.09.02-.17.05-.25.03-.08.08-.14.13-.2.06-.06.12-.1.2-.13.08-.03.16-.05.25-.05s.17.02.25.05c.08.03.14.08.2.13.06.06.1.12.13.2.03.08.05.16.05.25s-.02.17-.05.25c-.03.08-.08.14-.13.2-.06.06-.12.1-.2.13-.08.03-.16.05-.25.05s-.17-.02-.25-.05c-.08-.03-.14-.08-.2-.13s-.1-.12-.13-.2c-.03-.08-.05-.16-.05-.25ZM76.64,29.75c0,.12.02.22.06.31.04.09.1.16.17.21.07.05.16.07.26.07s.19-.02.26-.07.13-.12.17-.21c.04-.09.06-.19.06-.31s-.02-.22-.06-.31c-.04-.09-.1-.16-.17-.21-.08-.05-.16-.07-.26-.07s-.19.02-.26.07-.13.12-.17.21c-.04.09-.06.19-.06.31Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.73,29.78v-.04h.44v.47c-.05.05-.12.09-.19.12-.08.03-.16.04-.26.04s-.19-.02-.27-.05c-.08-.03-.15-.08-.21-.13-.06-.06-.11-.12-.14-.2-.03-.08-.05-.16-.05-.25s.02-.17.05-.25c.03-.08.08-.14.14-.2.06-.06.13-.1.21-.13.08-.03.17-.05.27-.05.04,0,.09,0,.14,0s.1.01.14.02.08.02.11.04v.1h-.02s-.1-.07-.17-.09-.13-.03-.21-.03c-.11,0-.2.02-.28.07-.08.05-.15.12-.19.21-.04.09-.07.19-.07.31s.02.22.07.31c.05.09.11.16.19.21.08.05.18.07.28.07.07,0,.13,0,.19-.03s.11-.04.15-.08v-.45h-.32Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.56,30.35v-1.21h.12v1.21h-.12Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.13,30.35v-1.21h.53v.08l-.3-.04c-.05,0-.09,0-.11,0v.53s.05,0,.11,0l.28-.02v.08l-.28-.02c-.06,0-.09,0-.11,0v.58s.06,0,.11-.01l.31-.04v.08h-.53Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.05,31.99v1.05h-.1v-.96h0l-.36.7h-.05l-.41-.61h0l.03.88h-.1l.04-1.07h.03l.47.7h0l.35-.68h.11Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.43,31.99h.1v.63c0,.12.03.21.09.28.06.07.14.1.25.1.07,0,.13-.01.18-.04.05-.03.09-.06.12-.11.03-.05.04-.1.04-.16l-.03-.71h.1l-.03.71c0,.12-.04.21-.11.27-.07.06-.16.09-.29.09-.13,0-.24-.04-.32-.12s-.11-.19-.11-.32v-.63Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.64,31.99h.1v1.02s.05,0,.09,0l.25-.04v.08h-.44v-1.05Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5,33.04v-1.02s-.05,0-.09,0l-.29.04v-.08h.88v.08l-.29-.04s-.08,0-.09,0v1.02h-.1Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.23,33.04v-1.05h.1v1.05h-.1Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.72,33.04v-1.05h.33c.12,0,.22.02.3.07s.15.11.2.18c.05.08.07.17.07.27s-.02.2-.07.28c-.05.08-.12.14-.2.18s-.19.07-.3.07h-.33ZM51.05,32.03h-.23v.98h.23c.14,0,.26-.04.34-.13.08-.09.12-.21.12-.36s-.04-.27-.12-.36c-.08-.09-.2-.13-.34-.13Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.94,33.04v-1.05h.1v1.05h-.1Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.34,33.01v-.09h.02s.08.06.13.08c.05.02.1.03.15.03.07,0,.12-.02.17-.06s.06-.09.06-.15c0-.04,0-.07-.02-.1s-.04-.06-.08-.09-.08-.06-.15-.1c-.04-.02-.08-.05-.12-.08-.04-.03-.07-.06-.1-.1-.03-.04-.04-.08-.04-.13,0-.08.03-.14.08-.18.05-.05.13-.07.22-.07.04,0,.08,0,.13.01.05,0,.08.02.11.03v.08h-.02c-.06-.06-.13-.09-.22-.09-.06,0-.12.02-.16.05-.04.03-.06.08-.06.13,0,.04.01.08.03.11s.05.06.08.08.07.05.11.07c.04.03.09.05.13.08.04.03.08.06.11.1.03.04.04.09.04.15,0,.06-.01.11-.04.15-.03.04-.06.08-.11.1-.05.02-.1.04-.17.04-.04,0-.09,0-.14-.02s-.11-.02-.15-.04Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.08,32.91v.09s-.07.02-.11.03-.08.02-.12.02c-.04,0-.08,0-.11,0-.08,0-.16-.01-.23-.04-.07-.03-.13-.07-.18-.11s-.09-.11-.12-.17c-.03-.07-.04-.14-.04-.22s.01-.15.04-.22c.03-.07.07-.12.12-.17s.11-.09.18-.11c.07-.03.14-.04.23-.04.03,0,.07,0,.11,0s.08.01.12.02c.04,0,.07.02.1.03v.08h-.02s-.08-.06-.14-.08c-.06-.02-.11-.03-.17-.03-.09,0-.17.02-.24.06-.07.04-.12.1-.16.18-.04.08-.06.17-.06.27s.02.19.06.27c.04.08.09.14.16.18.07.04.15.06.24.06.07,0,.13-.01.19-.03.06-.02.11-.05.14-.08h0Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.38,33.04v-1.05h.1v1.05h-.1Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.88,33.04v-1.05h.19c.12,0,.21.03.28.08.07.05.1.12.1.21s-.03.16-.1.22c-.07.05-.16.08-.28.08h-.09v.46h-.1ZM55.06,32.03h-.09v.51h.09c.18,0,.27-.09.27-.26s-.09-.26-.27-.26Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.73,31.99h.1v1.02s.05,0,.09,0l.25-.04v.08h-.44v-1.05Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.42,33.04v-1.05h.1v1.05h-.1Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.89,33.04l.04-1.07h.02l.75.91h0l-.03-.89h.1s-.04,1.07-.04,1.07h-.02l-.75-.91h0l.03.89h-.1Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.99,33.04l.4-1.05h.09l.4,1.05h-.11l-.19-.49h-.34l-.15.49h-.11ZM58.41,32.07l-.14.44h.32l-.17-.44h0Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.13,33.04v-1.05h.1v1.05h-.1Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.63,31.99h.2c.11,0,.19.02.25.07.06.04.09.11.09.19,0,.06-.02.11-.05.16s-.09.07-.16.08h0c.07.02.12.05.16.1.04.05.07.11.09.18.02.07.04.12.06.15.02.04.04.06.06.08.02.02.05.03.08.04h0s-.06,0-.06,0c-.04,0-.08,0-.11-.02-.03-.02-.05-.04-.07-.08-.02-.04-.04-.09-.06-.16-.03-.1-.07-.18-.12-.22s-.11-.06-.18-.06h0v-.03h0c.16,0,.24-.07.24-.22s-.08-.22-.23-.22h-.1v1.01h-.1v-1.05Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.59,33.04v-1.05h.46v.07l-.26-.03s-.08,0-.09,0v.46s.04,0,.09,0h.25s0,.05,0,.05l-.25-.02s-.08,0-.09,0v.5s.05,0,.09,0l.27-.03v.07h-.46Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.77,33.04v-1.05h.19c.12,0,.21.03.28.08.07.05.1.12.1.21s-.03.16-.1.22c-.07.05-.16.08-.28.08h-.09v.46h-.1ZM61.96,32.03h-.09v.51h.09c.18,0,.27-.09.27-.26s-.09-.26-.27-.26Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.63,31.99h.2c.11,0,.19.02.25.07.06.04.09.11.09.19,0,.06-.02.11-.05.16s-.09.07-.16.08h0c.07.02.12.05.16.1.04.05.07.11.09.18.02.07.04.12.06.15.02.04.04.06.06.08.02.02.05.03.08.04h0s-.06,0-.06,0c-.04,0-.08,0-.11-.02-.03-.02-.05-.04-.07-.08-.02-.04-.04-.09-.06-.16-.03-.1-.07-.18-.12-.22s-.11-.06-.18-.06h0v-.03h0c.16,0,.24-.07.24-.22s-.08-.22-.23-.22h-.1v1.01h-.1v-1.05Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.48,33.04l.4-1.05h.09l.4,1.05h-.11l-.19-.49h-.34l-.15.49h-.11ZM63.89,32.07l-.14.44h.32l-.17-.44h0Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.62,33.04v-1.05h.1v1.05h-.1ZM65.27,33.04l-.49-.54.46-.51h.13l-.49.47.54.58h-.13Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.87,33.04v-1.02s-.05,0-.09,0l-.29.04v-.08h.88v.08l-.29-.04s-.08,0-.09,0v1.02h-.1Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6,33.04v-1.05h.1v1.05h-.1Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.09,32.95v-.96h.1v.95c0,.13-.02.22-.05.29-.03.07-.09.12-.16.15h0s.07-.08.09-.15c.02-.07.03-.16.03-.29Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.59,33.04v-1.05h.1v1.05h-.1ZM68.23,33.05l-.49-.54.46-.51h.13s-.49.47-.49.47l.54.58h-.13Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.84,25.15c15.67-.15,31.33-.16,47,0-15.67.16-31.33.15-47,0h0Z",
    style: {
      fill: "#7fba27"
    }
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoHelixNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-helix-new.88e48bda.svg";
export { ForwardRef as ReactComponent };